var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgOrders = function SvgOrders(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    "data-width-12": 11,
    "data-width-16": 14,
    "data-width-20": 18,
    "data-width-24": 21,
    "data-width-28": 24,
    "data-width-72": 62,
    viewBox: "0 0 10.25 8.6",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M3.808.16 1.951 2.947H.968a1 1 0 0 0-.94 1.235l.875 3.5a1.235 1.235 0 0 0 1.2.94h6a1.235 1.235 0 0 0 1.22-.945l.875-3.5a1 1 0 0 0-.96-1.23H8.221L6.378.18a.37.37 0 0 0-.5-.105.38.38 0 0 0-.105.5l1.58 2.37H2.847L4.413.556a.38.38 0 0 0-.105-.5.37.37 0 0 0-.5.105m4.25 3.536H.968a.245.245 0 0 0-.235.3l.88 3.5a.5.5 0 0 0 .47.37h6.02a.5.5 0 0 0 .47-.37l.88-3.5a.24.24 0 0 0-.045-.205.25.25 0 0 0-.19-.095H8.164a.4.4 0 0 1-.126.02zM6.603 6.77a.375.375 0 0 1-.375-.375v-1.23a.375.375 0 0 1 .75 0v1.23a.37.37 0 0 1-.375.375m-3.12-.028a.375.375 0 0 0 .52-.348v-1.23a.375.375 0 0 0-.75 0v1.23a.37.37 0 0 0 .23.348",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgOrders);
export default ForwardRef;